import React from "react";

interface CarouselSlideTypeBadgeProps {
    type: "image" | "video";
}

export const CarouselSlideTypeBadge: React.FC<CarouselSlideTypeBadgeProps> = ({ type }) => {
    return (
        <span className={`slideCard__typeBadge slideCard__typeBadge--${type}`}>
            {type === "video" ? "Video" : "Image"}
        </span>
    );
};